import * as React from "react";
import { NavigationItem } from "@atlassiansox/microscopekit";
import OverviewIcon from "@atlaskit/icon/glyph/overview";
// These links show up in the navigation sidebar for urls starting with `/services/{service_name}`
export class LinterNavigation extends React.Component {
    render() {
        return (React.createElement(React.Fragment, null,
            React.createElement(NavigationItem, { icon: React.createElement(OverviewIcon, { label: "Linter" }), text: "Linter", href: `/services/${encodeURIComponent(this.props.id)}/linter` })));
    }
}
